export default __webpack_public_path__ + "static/media/mSafety_logo_black.a28ae49c.png";